import React from 'react';
import { CodeSetItemRow } from 'src/components/CodeSetSelector';

interface VolumeItemProps {
  volume: {
    id: number;
    label: string;
    status?: string;
    volumeType: string;
  };
  isSelected: boolean;
  subtitle: string;
  onSelect: () => void;
  onEdit: (e: React.MouseEvent) => void;
  onDelete: (e: React.MouseEvent) => void;
  onReactivate?: (e: React.MouseEvent) => void;
  onDragStart?: (e: React.DragEvent) => void;
  onDragEnd?: (e: React.DragEvent) => void;
}

/**
 * Adapts a Discovery "volume" to the shared CodeSetItemRow. Row presentation
 * (label, subtitle, status chip, selection, quick-actions) lives in the shared
 * row so all selector dropdowns stay visually consistent.
 */
const VolumeItem: React.FC<VolumeItemProps> = ({
  volume,
  isSelected,
  subtitle,
  onSelect,
  onEdit,
  onDelete,
  onReactivate,
  onDragStart,
  onDragEnd,
}) => {
  const kind =
    volume.volumeType === 'advancedSearch' || volume.volumeType === 'aiSearch'
      ? 'advancedSearch'
      : volume.volumeType === 'filterSet'
        ? 'filterSet'
        : 'cohort';

  return (
    <CodeSetItemRow
      label={volume.label}
      kind={kind}
      status={volume.status}
      subtitle={subtitle}
      isSelected={isSelected}
      onSelect={onSelect}
      onEdit={onEdit}
      onDelete={onDelete}
      onReactivate={onReactivate}
      draggable={Boolean(onDragStart)}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      data-testid={`volume-item-${volume.volumeType}-${volume.id}`}
    />
  );
};

export default VolumeItem;
